/*
	:: Mобильное меню 2.5 ::

Принимает:
	btnOpenTag - тег кнопки открытия
	btnCloseTag (опционально) - тег кнопки закрытия
	bodyClass (опционально) - класс для body

Действие: при нажатии на кнопку убирает/добавляет класс
is-menu-open у body

если задана только одна кнопка (btnOpenTag), она является переключателем
если заданы 2 кнопки, то btnOpenTag открывает, а btnCloseTag закрывает меню
наличие btnCloseTag позволяет закрывать меню при нажатии на ссылку

Подключение:

// мобильное меню
const mobileMenu = require("./mobileMenu");

// мобильное меню
mobileMenu ({
	btnOpenTag: ".js-btn-mobile-menu-open",
	btnCloseTag: ".js-btn-mobile-menu-close"
	bodyClass: "is-menu-open"
});

*/

let f = function (option) {
  // console.log("подключено мобильное меню");

  // открытие и закрытие меню
  if (document.querySelector(option.btnOpenTag)) {
    // переменные
    const btnOpenElList = document.querySelectorAll(option.btnOpenTag);
    let btnCloseEl;
    let linkCloseListNode;
    let animateElement;
    const bodyClass = option.bodyClass || "is-menu-open";

    if (document.querySelector(option.btnCloseTag)) {
      btnCloseEl = document.querySelector(option.btnCloseTag);
    }

    if (option.closeAnimate) {
      animateElement = document.querySelector(option.animateElementSelector);
    }

    // функции
    const openFn = (evt) => {
      document.body.classList.add(bodyClass);
      if (option.closeAnimate) {
        animateElement.classList.add(bodyClass);
      }
      if (option.isHeader && window.matchMedia("(min-width: 1200px)").matches) {
        evt.currentTarget.addEventListener("click", closeFn);
      }

      // console.log("mobile-menu open");
    };

    const closeFn = (evt) => {
      if (option.closeAnimate) {
        let timeout;
        if (option.isHeader && window.matchMedia("(min-width: 1200px)").matches) {
          timeout = 100;
          evt.currentTarget.removeEventListener("click", closeFn);
        } else {
          timeout = 600;
        }
        setTimeout(() => {
          document.body.classList.remove(bodyClass);
        }, timeout);
        animateElement.classList.remove(bodyClass);
      } else {
        document.body.classList.remove(bodyClass);
      }

      // console.log("mobile-menu close");
    };

    const toggleFn = () => {
      document.body.classList.toggle(bodyClass);
      // console.log("mobile-menu toggle");
    };

    // варианты
    // если есь кнопка закрытия, ищем все такие кнопки
    if (option.isHeader) {
      if (window.matchMedia("(min-width: 1200px)").matches) {
        btnOpenElList.forEach((btnOpenEl) => {
          btnOpenEl.addEventListener("click", openFn);
        });
      } else {
        btnOpenElList.forEach((btnOpenEl) => {
          btnOpenEl.addEventListener("click", openFn);
        });

        // закрытие по ссылкам
        if (document.querySelector(option.btnCloseTag)) {
          linkCloseListNode = document.querySelectorAll(option.btnCloseTag);

          linkCloseListNode.forEach((linkCloseEl) => {
            linkCloseEl.addEventListener("click", closeFn);
          });
        }
      }
    } else {
      if (btnCloseEl) {
        btnOpenElList.forEach((btnOpenEl) => {
          btnOpenEl.addEventListener("click", openFn);
        });

        // закрытие по ссылкам
        if (document.querySelector(option.btnCloseTag)) {
          linkCloseListNode = document.querySelectorAll(option.btnCloseTag);

          linkCloseListNode.forEach((linkCloseEl) => {
            linkCloseEl.addEventListener("click", closeFn);
          });
        }
      } else {
        // если нет, то используем только кнопку открытия
        btnOpenElList.forEach((btnOpenEl) => {
          btnOpenEl.addEventListener("click", toggleFn);
        });
      }
    }
  }
};

export default f;